export default __webpack_public_path__ + "static/media/543.8a0ccb09.jpg";